import { API, Image_API,API_DISPLAY } from "redux/api";
import Axios from "axios";

export const uploadImageApi = (formData) => {
    return API_DISPLAY({
      method: "post",
      url: `/display/media/upload`,
      data: formData,
    });
  };
 
 
  export const deleteImageApi = (mediaId) => {
 
 
   
 
    return API_DISPLAY({
      method: "DELETE",
      url: `/display/media/delete?mediaId=${mediaId}`,
    });
  };
 
  export const deletedisplayApi = (displayId) => {
    return API_DISPLAY({
      method: "DELETE",
      url: `/display/location?displayId=${displayId}`,
    });
  };
 
 
 
  export const imageLibrarygetApi = (locationid) => {
    return API_DISPLAY({
      method: "GET",
      url: `/display/media/library?locationId=${locationid}`,
    });
  };
 
  export const DisplaygetApi = (locationid) => {
    return API_DISPLAY({
      method: "GET",
      url: `/display/location?locationId=${locationid}`,
    });
  };
 
 
 
 
 
  export const createDisplayApi = (data) => {
 
   
 
    return API_DISPLAY({
      method: "post",
      url: `/display/template`,
      data: data,
      headers: {
        "Content-Type": "application/json",
     
      },
   
    });
  };
 
 
  export const templateApi = (locationid) => {
    return API_DISPLAY({
      method: "GET",
      url: `/display/template`,
    });
  };